import { NgModule } from 'angular-ts-decorators';
import { TranslationsProvider } from '@core/app/scripts/services/translations';

require('@core/app/scripts/app');

import { SessionObject } from '@shared/app/scripts/services/current-session';
import { Session } from '@shared/app/scripts/services/session';

// own dependencies
require('angular-validation-match');
require('angular-matchmedia/dist/angular-matchmedia');
require('ng-password-strength');
require('angular-chart.js');

import { components } from './components/legacy';
import { directives } from './directives';
import { services } from './services';

import { timer, of, throwError } from 'rxjs';
import { takeUntil, switchMap, last } from 'rxjs/operators';

/**
 * # gateApp
 *
 * Main module of the application.
 */
@NgModule({
  id: 'gateApp',
  declarations: components.concat(directives),
  providers: services,
  imports: [
    'coreModule',
    'validation.match',
    'angular-matchmedia',
    'ngPasswordStrength',
    'chart.js',
  ],
})
export class GateApp {
  static config($routeProvider, translationsProvider: TranslationsProvider) {
    'ngInject';

    // TODO GATE-297 move access controll to components
    const onlyLoggedIn = {
      isLogged: /*@ngInject*/ function (
        $q: ng.IQService,
        scheduler,
        session: Session,
      ) {
        return session.current$
          .pipe(
            takeUntil(timer(1000)),
            last(),
            switchMap((value: SessionObject) => {
              if (value.isLogged) {
                return of(value);
              } else {
                return throwError('not logged in');
              }
            }),
          )
          .toPromise(<PromiseConstructorLike>$q);
      },
    };

    $routeProvider
      .when('/home', {
        template: '<home></home>',
        resolve: onlyLoggedIn,
      })
      .when('/support', {
        template: '<support></support>',
      })
      .when('/password-reset', {
        template: '<password-reset></password-reset>',
      })
      .when('/request-password-reset', {
        template: '<request-password-reset></request-password-reset>',
      })
      .when('/activate', {
        template: '<activate></activate>',
      })
      .when('/choose-tenant', {
        template: '<choose-tenant></choose-tenant>',
        resolve: onlyLoggedIn,
      })
      .when('/profile/:username?', {
        template: '<profile></profile>',
      })
      .when('/landing-page', {
        template: '<landing-page></landing-page>',
      })
      .when('/email-verification/:key?/:email?', {
        template: '<email-verification></email-verification>',
      })
      .when('/privacy-policy', {
        template: '<privacy-policy></privacy-policy>',
      })
      .when('/terms-and-conditions', {
        template: '<terms-and-conditions></terms-and-conditions>',
      })
      .otherwise({
        redirectTo: '/home',
      });

    // supported i18n list
    translationsProvider.translations(
      'nl-nl',
      require('../translations/nl-nl.json'),
    );
    translationsProvider.translations(
      'en-gb',
      require('../translations/en-gb.json'),
    );
    translationsProvider.translations(
      'fr-fr',
      require('../translations/fr-fr.json'),
    );
    translationsProvider.translations(
      'de-de',
      require('../translations/de-de.json'),
    );
    translationsProvider.translations(
      'it-it',
      require('../translations/it-it.json'),
    );
    translationsProvider.translations(
      'es-es',
      require('../translations/es-es.json'),
    );
  }

  static run(
    $rootScope: ng.IRootScopeService,
    $location: ng.ILocationService,
    $templateCache: ng.ITemplateCacheService,
    $window: ng.IWindowService,
    numberFilter: ng.IFilterNumber,
  ) {
    'ngInject';

    $templateCache.put(
      'src/directive/ng-password-strength.tpl.html',
      require('ng-password-strength/app/src/directive/ng-password-strength.tpl.html')
        .default,
    );

    $rootScope.$on('$routeChangeError', () => {
      $location.url('/landing-page');
    });

    // Make graphs redraw on page resize. As the charts are moving more and more
    // to chartJs this line will not be necessary
    $window.addEventListener('resize', () => {
      $rootScope.$broadcast('data:loaded');
    });

    // bad style! Hopefully we can find some nicer solution for setting
    // the config, but for now it makes job done.
    $window.Chart.defaults.global.colours = [
      '#01A0B0',
      '#7234ad',
      '#97BBCD',
      '#DCDCDC',
      '#F7464A',
      '#46BFBD',
      '#FDB45C',
      '#949FB1',
      '#4D5360',
    ];

    $window.Chart.defaults.global.animation = false;
    $window.Chart.defaults.global.maintainAspectRatio = false;
    $window.Chart.defaults.global.multiTooltipTemplate = (entry) => {
      const label = entry.datasetLabel ? entry.datasetLabel + ': ' : '';
      return label + numberFilter(entry.value, 2);
    };

    $window.Chart.defaults.global.tooltipTemplate = (entry) => {
      const label = entry.datasetLabel ? entry.datasetLabel + ': ' : '';
      return label + numberFilter(entry.value, 2);
    };
  }
}

require('./components/no-decorators');
require('./directives/no-decorators');
